import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import CtaOne from "@components/CTA/CtaOne";
import PricingCards from "@components/Cards/PricingCards";
import { MdStars } from "react-icons/md";
import { Switch } from "@components/MiniComponents";
import Slider from "@components/Slider";
import FAQ from "@components/FAQ";
import Subscribe from "@components/Subscribe";
import { PiArrowBendUpRightThin } from "react-icons/pi";
import PricingComparisons from "@components/Comparisons/PricingComparisons";
import Head from "next/head";
import { BASE_ASSETS_URL } from "../../../constants/constants";
import PricingTable from "@components/Pricing/PricingTable";
import SocialProof from "@components/SocialProof";
import { createUTMQueryParams } from "@utils/signature_owner";
import ApiAddonPricingCard from "@components/Pricing/ApiAddonPricingCard";
import FeatureInfoPopup from "@components/Cards/FeatureImagePopup";
import { BsChevronCompactDown } from "react-icons/bs";
import { BsArrowDownCircle } from "react-icons/bs";
import { motion } from "framer-motion";
import PricingTable2 from "@components/Pricing/PricingTable2";
import { FaRegCircleCheck } from "react-icons/fa6";
import GradientCheckIcon from "@components/Cards/GradientCheckIcon";
import ApiAddonPricingCard2 from "@components/Pricing/ApiAddonPricingCard2";
import { CLMButtonPrimary } from "components/CLM/v3/Buttons";
import PricingComparisons2 from "@components/Comparisons/PricingComparisions2";
import PricingCardsV2 from "@components/Cards/PricingCardsV2";
import PricingCardV3 from "@components/Cards/PricingCard3";
import AnimatedLogos from "components/customers/AnimatedLogos";
import RequestDemo from "components/request-demo";
import PricingCardsCLM from "components/CLM/PricingCardsCLM";

const freeTrialData = {
  title: "Forever Free",
  description: "Start your digital journey with BoloSign.",
  price: 0,
  pricingType: "mo",
  pricingTag: 5,
  featuresIcon: <GradientCheckIcon />,
  bgColor: "bg-[#d7f3fe]",
  quantityName: "",
  recommended: false,
  additionalSeatPrice: 29,
  featuresTitle: "Key Features :",
  features: [
    {
      name: "Collect Signatures in Forms",
      image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
    },
    {
      name: "5 Form Submissions",
      image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
    },
    {
      name: "2 PDFs",
      image: `${BASE_ASSETS_URL}/v2/ltd/features/pdf.png`,
    },
    {
      name: "2 Template Responses",
      image: `${BASE_ASSETS_URL}/v2/ltd/features/pdf-template.png`,
    },
    {
      name: "5 Signature Forms",
      image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
    },
    {
      name: "Audit Log and History",
      image: `${BASE_ASSETS_URL}/v2/ltd/features/audit-trail.png`,
    },
    {
      name: "Structured Folder System",
      image: `${BASE_ASSETS_URL}/v2/ltd/features/create-files-folders.png`,
    },
    {
      name: "Signing Order",
      image: `${BASE_ASSETS_URL}/v2/ltd/features/signing-order.png`,
    },
    {
      name: "Certification of completion & electronic record disclosure",
      image: `${BASE_ASSETS_URL}/v2/ltd/features/ueta.png`,
    },
    {
      name: "Form fields: drop-down, radio, checkbox, matrix, etc.",
      image: `${BASE_ASSETS_URL}/v2/ltd/features/doc-editor.png`,
    },
    {
      name: "Secure completed contracts with tamper-proof trust seal",
    },
  ],
  pricingLink: "#",
};

const monthlyPricing = [
  // {
  //   title: "Forever Free",
  //   description: "Start your digital journey with BoloSign.",
  //   price: 0,
  //   pricingType: "mo",
  //   pricingTag: 5,
  //   featuresIcon: <MdStars />,
  //   bgColor: "bg-[#d7f3fe]",
  //   quantityName: "",
  //   recommended: false,
  //   transparent: true,
  //   additionalSeatPrice: 29,
  //   featuresTitle: "Key Features :",
  //   features: [
  //     {
  //       name: "Collect Signatures in Forms",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
  //     },
  //     {
  //       name: "5 Form Submissions",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
  //     },
  //     {
  //       name: "2 PDFs",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/pdf.png`,
  //     },
  //     {
  //       name: "2 Template Responses",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/pdf-template.png`,
  //     },
  //     {
  //       name: "5 Signature Forms",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
  //     },
  //     {
  //       name: "Audit Log and History",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/audit-trail.png`,
  //     },
  //     {
  //       name: "Structured Folder System",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/create-files-folders.png`,
  //     },
  //     {
  //       name: "Signing Order",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/signing-order.png`,
  //     },
  //     {
  //       name: "Certification of completion & electronic record disclosure",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/ueta.png`,
  //     },
  //     {
  //       name: "Form fields: drop-down, radio, checkbox, matrix, etc.",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/doc-editor.png`,
  //     },
  //   ],
  //   pricingLink: "#",
  // },
  {
    title: "Freelancer",
    description: "For people just looking to take signatures in Forms.",
    price: 15,
    pricingType: "mo",
    pricingTag: 100,
    featuresIcon: <GradientCheckIcon />,
    bgColor: "bg-[#f8e3f8]",
    quantityName: "Pack",
    recommended: false,
    additionalSeatPrice: 29,
    featuresTitle: `Everything in <a href="#bolosign-free-plan" class="underline">Free Plan</a>, plus :`,
    features: [
      {
        name: "100 Form Submissions",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
      },
      {
        name: "10 PDFs",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/pdf.png`,
      },
      {
        name: "10 Template Responses",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/pdf-template.png`,
      },
      {
        name: "10 Signature Forms",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
      },
      {
        name: "Form Branding",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/form-branding.png`,
      },
      {
        name: "Send A Copy of Generated PDFs",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/generate-response-pdf.png`,
      },
      {
        name: "PDF Link for sharing",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/generate-signing-link.png`,
      },
      {
        name: "Secure completed contracts with tamper-proof trust seal",
      },
    ],
    pricingLink: "#",
  },
  {
    title: "Team",
    description:
      "For people who want a one-stop solution to take signatures in Form and PDF.",
    price: 69,
    pricingType: "mo",
    pricingTag: 500,
    featuresIcon: <GradientCheckIcon />,
    bgColor: "bg-[#b8f6b7]",
    quantityName: "Pack",
    recommended: true,
    additionalSeatPrice: 29,
    featuresTitle: "Everything in Freelancer, plus :",
    features: [
      {
        name: "500 Form Submissions",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
      },
      {
        name: "Unlimited Members*",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/members.png`,
      },
      {
        name: "Unlimited PDFs*",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/pdf.png`,
      },
      {
        name: "Unlimited Reusable Templates*",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/pdf-template.png`,
      },
      {
        name: "Unlimited Signature Forms*",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
      },
      {
        name: "Form Analytics",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/form-analytics.png`,
      },
      {
        name: "Import Fields",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/import-fields.png`,
      },
      {
        name: "Admin Dashboard for User Management",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/custom-user-roles.png`,
      },
      {
        name: "Share Templates with Team Members",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/team-workspaces.png`,
      },
      {
        name: "Custom Watermark in PDFs",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/watermark.png`,
      },
      {
        name: "Google Drive Integration",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/google-drive.png`,
      },
      {
        name: "Custom PDF Name Generation",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/custom-pdf-name.png`,
      },
      {
        name: "Bulk Download",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/bulk-download.png`,
      },
      {
        name: "Bulk Send",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/bulk-send.png`,
      },
      {
        name: "PDF Variables",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/variables.png`,
      },
      {
        name: "Dropbox and OneDrive integrations",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/dropbox-onedrive.png`,
      },
      {
        name: "Secure completed contracts with tamper-proof trust seal",
      },
    ],
    pricingLink: "#",
  },
  {
    title: "Growing Business",
    description: "Designed for businesses experiencing growth and expansion.",
    price: 129,
    pricingType: "mo",
    pricingTag: "Unlimited",
    featuresIcon: <GradientCheckIcon />,
    bgColor: "bg-[#fee5cd]",
    // quantityName: "Workspace",
    recommended: false,
    additionalSeatPrice: 29,
    featuresTitle: "Everything in Team, plus :",
    features: [
      {
        name: "Unlimited Form Submissions*",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
      },
      {
        name: "Unlimited Workspaces",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/team-workspaces.png`,
      },
      {
        name: "Redirection URL in Forms",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/custom-redirection-url.png`,
      },
      {
        name: "Redirection URL in PDFs",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/custom-redirection-url.png`,
      },
      {
        name: "Email Branding",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/email-subject-body.png`,
      },
      {
        name: "Read Receipts",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/audit-trail.png`,
      },
      {
        name: "Password proctected PDFs",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/password-protection.png`,
      },
      {
        name: "Stripe",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/stripe-integration.png`,
      },

      // {
      //   name: "Hubspot, Pipedrive, GoHighLevel integrations",
      //   image: `${BASE_ASSETS_URL}/v2/ltd/features/crm-integrations.png`,
      // },
      {
        name: "Create Custom Data Fields",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/custom-data-fields.png`,
      },
      {
        name: "Custom Email",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/custom-email.png`,
      },
      {
        name: "Custom Email Subject & Email Body",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/email-subject-body.png`,
      },
      {
        name: "Customize Form URLs",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/custom-url.png`,
      },
      {
        name: "Access Code Verification",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/access-code-verification.png`,
      },
      // {
      //   name: "Approval Workflow",
      //   image: `${BASE_ASSETS_URL}/v2/ltd/features/approval-workflow.png`,
      // },
      {
        name: "Secure completed contracts with tamper-proof trust seal",
      },
    ],
    pricingLink: "#",
  },
  {
    title: "Enterprise",
    description: "For large enterprises demanding top-tier solutions.",
    price: "Get tailored pricing for high-volume document needs and seats",
    pricingType: "mo",
    pricingTag: "Unlimited",
    featuresIcon: <MdStars />,
    bgColor: "bg-[#d7f3fe]",
    buttonText: "Book A Demo",
    transparent: false,
    recommended: false,
    featuresTitle: "Everything in Business, plus :",
    features: [
      {
        name: "Enhance security with single sign-on (SSO)",
        // image: `${BASE_ASSETS_URL}/v2/ltd/features/sso.png`,
      },
      {
        name: "Bulk send individual requests to a large list of signers",
        // image: `${BASE_ASSETS_URL}/v2/ltd/features/bulk-send.png`,
      },
      {
        name: "Hubspot, Pipedrive, GoHighLevel and other CRM integrations",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/crm-integrations.png`,
      },
      {
        name: "Approval Workflow",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/approval-workflow.png`,
      },
      {
        name: "Custom feature requests development",
      },
      {
        name: "Receive assisted onboarding from a dedicated Success Manager",
        // image: `${BASE_ASSETS_URL}/v2/ltd/features/success-manager.png`,
      },
      {
        name: "Secure completed contracts with tamper-proof trust seal",
      },
      {
        name: "Import from Docusign",
      },
    ],
  },
];

const yearlyPricing = [
  // {
  //   title: "Forever Free",
  //   description: "Start your digital journey with BoloSign.",
  //   price: 0,
  //   pricingType: "yr",
  //   pricingTag: 5,
  //   featuresIcon: <MdStars />,
  //   bgColor: "bg-[#d7f3fe]",
  //   quantityName: "",
  //   recommended: false,
  //   transparent: true,
  //   additionalSeatPrice: 29,
  //   featuresTitle: "Key Features :",
  //   features: [
  //     {
  //       name: "Collect Signatures in Forms",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
  //     },
  //     {
  //       name: "5 Form Submissions",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
  //     },
  //     {
  //       name: "2 PDFs",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/pdf.png`,
  //     },
  //     {
  //       name: "2 Template Responses",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/pdf-template.png`,
  //     },
  //     {
  //       name: "5 Signature Forms",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
  //     },
  //     {
  //       name: "Audit Log and History",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/audit-trail.png`,
  //     },
  //     {
  //       name: "Structured Folder System",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/create-files-folders.png`,
  //     },
  //     {
  //       name: "Signing Order",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/signing-order.png`,
  //     },
  //     {
  //       name: "Certification of completion & electronic record disclosure",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/ueta.png`,
  //     },
  //     {
  //       name: "Form fields: drop-down, radio, checkbox, matrix, etc.",
  //       image: `${BASE_ASSETS_URL}/v2/ltd/features/doc-editor.png`,
  //     },
  //   ],
  //   pricingLink: "#",
  // },
  {
    title: "Freelancer",
    description: "For people just looking to take signatures in Forms.",
    price: 10,
    pricingType: "yr",
    pricingTag: 100,
    featuresIcon: <GradientCheckIcon />,
    bgColor: "bg-[#f8e3f8]",
    quantityName: "Pack",
    recommended: false,
    additionalSeatPrice: 29,
    featuresTitle: `Everything in <a href="#bolosign-free-plan" class="underline">Free Plan</a>, plus :`,
    features: [
      {
        name: "100 Form Submissions",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
      },
      {
        name: "10 PDFs",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/pdf.png`,
      },
      {
        name: "10 Template Responses",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/pdf-template.png`,
      },
      {
        name: "10 Signature Forms",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
      },
      {
        name: "Form Branding",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/form-branding.png`,
      },
      {
        name: "Send A Copy of Generated PDFs",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/generate-response-pdf.png`,
      },
      {
        name: "PDF Link for sharing",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/generate-signing-link.png`,
      },
      {
        name: "Secure completed contracts with tamper-proof trust seal",
      },
    ],
    pricingLink: "#",
  },
  {
    title: "Team",
    description:
      "For people who want a one-stop solution to take signatures in Form and PDF.",
    price: 49,
    pricingType: "yr",
    pricingTag: 500,
    featuresIcon: <GradientCheckIcon />,
    bgColor: "bg-[#b8f6b7]",
    quantityName: "Pack",
    recommended: true,
    additionalSeatPrice: 29,
    featuresTitle: "Everything in Freelancer, plus :",
    features: [
      {
        name: "500 Form Submissions",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
      },
      {
        name: "Unlimited Members*",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/members.png`,
      },
      {
        name: "Unlimited PDFs*",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/pdf.png`,
      },
      {
        name: "Unlimited Reusable Templates*",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/pdf-template.png`,
      },
      {
        name: "Unlimited Signature Forms*",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
      },
      {
        name: "Form Analytics",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/form-analytics.png`,
      },
      {
        name: "Import Fields",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/import-fields.png`,
      },
      {
        name: "Admin Dashboard for User Management",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/custom-user-roles.png`,
      },
      {
        name: "Share Templates with Team Members",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/team-workspaces.png`,
      },
      {
        name: "Custom Watermark in PDFs",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/watermark.png`,
      },
      {
        name: "Google Drive Integration",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/google-drive.png`,
      },
      {
        name: "Custom PDF Name Generation",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/custom-pdf-name.png`,
      },
      {
        name: "Bulk Download",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/bulk-download.png`,
      },
      {
        name: "Bulk Send",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/bulk-send.png`,
      },
      {
        name: "PDF Variables",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/variables.png`,
      },
      {
        name: "Dropbox and OneDrive integrations",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/dropbox-onedrive.png`,
      },
      {
        name: "Secure completed contracts with tamper-proof trust seal",
      },
    ],
    pricingLink: "#",
  },
  {
    title: "Growing Business",
    description: "Designed for businesses experiencing growth and expansion.",
    price: 99,
    pricingType: "yr",
    pricingTag: "Unlimited",
    featuresIcon: <GradientCheckIcon />,
    bgColor: "bg-[#fee5cd]",
    // quantityName: "Workspace",
    recommended: false,
    additionalSeatPrice: 29,
    featuresTitle: "Everything in Team, plus :",
    features: [
      {
        name: "Unlimited Form Submissions*",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
      },
      {
        name: "Unlimited Workspaces",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/team-workspaces.png`,
      },
      {
        name: "Redirection URL in Forms",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/custom-redirection-url.png`,
      },
      {
        name: "Redirection URL in PDFs",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/custom-redirection-url.png`,
      },
      {
        name: "Email Branding",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/email-subject-body.png`,
      },
      {
        name: "Read Receipts",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/audit-trail.png`,
      },
      {
        name: "Password proctected PDFs",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/password-protection.png`,
      },
      {
        name: "Stripe",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/stripe-integration.png`,
      },

      // {
      //   name: "Hubspot, Pipedrive, GoHighLevel integrations",
      //   image: `${BASE_ASSETS_URL}/v2/ltd/features/crm-integrations.png`,
      // },
      {
        name: "Create Custom Data Fields",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/custom-data-fields.png`,
      },
      {
        name: "Custom Email",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/custom-email.png`,
      },
      {
        name: "Custom Email Subject & Email Body",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/email-subject-body.png`,
      },
      {
        name: "Customize Form URLs",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/custom-url.png`,
      },
      {
        name: "Access Code Verification",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/access-code-verification.png`,
      },
      {
        name: "Reminders",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/reminders.png`,
      },
      // {
      //   name: "Approval Workflow",
      //   image: `${BASE_ASSETS_URL}/v2/ltd/features/approval-workflow.png`,
      // },
      {
        name: "Secure completed contracts with tamper-proof trust seal",
      },
    ],
    pricingLink: "#",
  },
  {
    title: "Enterprise",
    description: "For large enterprises demanding top-tier solutions.",
    price: "Get tailored pricing for high-volume document needs and seats",
    pricingType: "mo",
    pricingTag: "Unlimited",
    featuresIcon: <FaRegCircleCheck />,
    bgColor: "bg-[#d7f3fe]",
    buttonText: "Book A Demo",
    transparent: false,
    recommended: false,
    featuresTitle: "Everything in Business, plus :",
    features: [
      {
        name: "Enhance security with single sign-on (SSO)",
        // image: `${BASE_ASSETS_URL}/v2/ltd/features/sso.png`,
      },
      {
        name: "Bulk send individual requests to a large list of signers",
        // image: `${BASE_ASSETS_URL}/v2/ltd/features/bulk-send.png`,
      },
      {
        name: "Hubspot, Pipedrive, GoHighLevel and other CRM integrations",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/crm-integrations.png`,
      },
      {
        name: "Approval Workflow",
        image: `${BASE_ASSETS_URL}/v2/ltd/features/approval-workflow.png`,
      },
      {
        name: "Custom feature requests development",
      },
      {
        name: "Receive assisted onboarding from a dedicated Success Manager",
        // image: `${BASE_ASSETS_URL}/v2/ltd/features/success-manager.png`,
      },
      {
        name: "Secure completed contracts with tamper-proof trust seal",
      },
      {
        name: "Import from Docusign",
      },
    ],
  },
];

const companyLogos = [
  {
    url: `${BASE_ASSETS_URL}/case-studies/angelfire.png`,
    name: "Angelfire",
    haveCaseStudy: true,
    companyKey: "angel-fire".toLowerCase(),
  },
  {
    url: `${BASE_ASSETS_URL}/case-studies/transport.png`,
    name: "G & H Transport",
    haveCaseStudy: true,
    companyKey: "g-h-transport".toLowerCase(),
  },

  {
    url: `${BASE_ASSETS_URL}/case-studies/beaver.png`,
    name: "Beaver",
    haveCaseStudy: true,
    companyKey: "beaver".toLowerCase(),
  },
  {
    url: `${BASE_ASSETS_URL}/case-studies/shine-above.png`,
    name: "Shine Above",
    haveCaseStudy: true,
    companyKey: "shine-above".toLowerCase(),
  },
  {
    url: `${BASE_ASSETS_URL}/case-studies/harry-corry.png`,
    name: "Harry Corry",
    haveCaseStudy: true,
    companyKey: "harry-corry-ltd".toLowerCase(),
  },
  {
    url: `${BASE_ASSETS_URL}/case-studies/rethink.png`,
    name: "Rethink",
    haveCaseStudy: true,
    companyKey: "rethink".toLowerCase(),
  },
  {
    url: `${BASE_ASSETS_URL}/case-studies/mancosa.png`,
    name: "Mancosa",
    haveCaseStudy: true,
    companyKey: "mancosa".toLowerCase(),
  },
  {
    url: `${BASE_ASSETS_URL}/case-studies/aging-comfort.png`,
    name: "Aging Comfort",
    haveCaseStudy: true,
    companyKey: "aging-comfort".toLowerCase(),
  },
];

const apiMonthlyPricing = {
  title: "API",
  description:
    "Automate your signature workflow by integrating our API into your systems.",
  price: 20,
  pricingType: "mo",
  priceDetail: " + $0.2/document",
  featuresIcon: <MdStars />,
  recommended: false,
  features: [
    "100 Documents/mo Included",
    "$0.2 per Document Sent",
    "Can be purchased with any plan",
  ],
  // pricingLink: "https://buy.stripe.com/7sI17rbgueAB1La005",
};

const apiYearlyPricing = {
  title: "API",
  description:
    "Automate your signature workflow by integrating our API into your systems.",
  price: 20,
  pricingType: "mo",
  priceDetail: " + $0.2/document",
  featuresIcon: <MdStars />,
  recommended: false,
  features: [
    "100 Documents/mo Included",
    "$0.2 per Document Sent",
    "Can be purchased with any plan",
  ],
  // pricingLink: "https://buy.stripe.com/28o7vPgAO3VXgG4fZ5",
};
const tabs = [
  {
    id: "1",
    name: "CLM",
  },
  // {
  //   id: "3",
  //   name: "eSignature",
  // },
  {
    id: "2",
    name: "API",
  },
];
const planType = ["Monthly", "Yearly"];

const Pricing = () => {
  const [activeTab, setActiveTab] = useState("CLM");
  const [imagePopup, setImagePopup] = useState(false);
  const [isMonthly, setIsMonthly] = useState(false);
  const changeTab = () => {
    setIsMonthly(!isMonthly);
  };
  return (
    <div className="relative md:mt-20 mt-8">
      <Head>
        <meta charSet="utf-8" />
        <title>
          BoloSign CLM Pricing | Best Pricing | Highest Security
        </title>
        <meta
          name="description"
          content="Explore BoloSign CLM pricing plans designed for businesses of all sizes. Enjoy competitive rates, top-tier security, and flexible options to streamline your contract lifecycle management."
        />
        <meta name="geo.region" content="IN" />
        <meta name="geo.position" content="22.351115;78.667743" />
        <meta name="ICBM" content="22.351115, 78.667743" />
        <meta name="author" content="Boloforms" />
        <meta name="publisher" content="BoloForms" />
        <meta
          name="keywords"
          content="BoloSign CLM pricing, contract lifecycle management pricing, CLM plans, eSignature pricing, document management pricing, business contract solutions, secure eSignature pricing"
        />
        <meta
          property="og:url"
          content="https://www.bolosign.com/signature/pricing/"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="BoloSign CLM Pricing | Best Pricing | Highest Security"
        />
        <meta name="twitter:site" content="@boloforms" />
        <meta
          property="twitter:url"
          content="https://www.bolosign.com/signature/pricing/"
        />
        <meta
          name="twitter:title"
          content="BoloSign CLM Pricing | Best Pricing | Highest Security"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:creator" content="@boloforms" />
        <meta property="twitter:domain" content="https://bolosign.com" />
        <meta name="twitter:description" content="" />
        <meta property="og:description" content="" />
        <meta
          name="robots"
          content="INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
        />
        <link
          rel="canonical"
          href="https://www.bolosign.com/signature/pricing/"
        />
      </Head>

      <div className="">
        {/* pricing section  */}
        <div className="mx-auto w-full flex flex-col text-center ">
          <div className="w-full relative max-w-screen-xl mx-auto px-4 md:px-12">
            <h3 className="text-4xl md:text-6xl leading-snug mx-auto font-semibold">
              Request a Quote
              <br /> for your business
            </h3>
            <p className="mt-5 w-[85%] md:w-[50%] mx-auto text-[18px] font-medium">
              Schedule your personalized demo!
            </p>
          </div>
          <div className="w-full mt-8 bg-white ">
            <div className="flex justify-center items-center bg-gray-100 rounded-full p-2 w-fit mx-auto space-x-1 sm:space-x-2">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.name)}
                  className="relative z-10 px-6 py-2 text-sm sm:text-base rounded-full font-medium"
                >
                  {activeTab === tab.name && (
                    <motion.div
                      layoutId="active-pill"
                      className="absolute inset-0 z-0 bg-white rounded-full shadow-sm"
                      transition={{
                        type: "spring",
                        stiffness: 400,
                        damping: 30,
                      }}
                    />
                  )}
                  <span
                    className={`relative z-10 ${
                      activeTab === tab.name
                        ? "text-black"
                        : "text-gray-500 hover:text-black"
                    }`}
                  >
                    {tab.name}
                  </span>
                </button>
              ))}
            </div>

            {activeTab === "eSignature" && (
              <>
                <div className="w-full">
                  <div className="max-w-screen-xl mx-auto px-4 flex  justify-center items-center space-x-4 md:pb-8 pt-8 pb-12">
                    <div className="inline-flex justify-center items-center  gap-3">
                      <span
                        className={`md:text-xl text-sm  ${
                          isMonthly
                            ? "bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 bg-clip-text text-transparent font-bold"
                            : "text-gray-500 font-semibold"
                        }`}
                      >
                        Monthly
                      </span>
                      <button
                        onClick={changeTab}
                        className="relative w-12 h-8 bg-gray-300 rounded-full p-1 transition-colors duration-300"
                      >
                        <motion.div
                          layout
                          className="w-6 h-6 bg-white rounded-full shadow-md"
                          animate={{ x: isMonthly ? 0 : 16 }}
                          transition={{
                            type: "spring",
                            stiffness: 400,
                            damping: 30,
                          }}
                        />
                      </button>
                      <span
                        className={`md:text-xl text-sm  ${
                          !isMonthly
                            ? "bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 bg-clip-text text-transparent font-bold"
                            : "text-gray-500 font-semibold"
                        }`}
                      >
                        Annually{" "}
                        <span className="inline-flex justify-center items-center px-4 py-2  ml-2 bg-gray-100  rounded-md">
                          <span className="bg-purple/10  md:text-base text-xs bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 bg-clip-text text-transparent font-semibold">
                            Upto 40% Off
                          </span>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
                <PricingTable2
                  isMonthly={isMonthly}
                  monthlyPricing={monthlyPricing}
                  yearlyPricing={yearlyPricing}
                />
                {/* free trial  */}
                <section
                  id="bolosign-free-plan"
                  className="w-full mb-20 sm:mb-24 px-4 md:px-8 mt-10"
                >
                  <div className="w-full max-w-screen-xl mx-auto">
                    <FreePlanAccordion setImagePopup={setImagePopup} />
                  </div>
                </section>
                {/* comaparisons table  */}
                <div id="bolosign-pricing-comparison-table" className="py-10">
                  <PricingComparisons2 />
                </div>
                {/* add-ons  */}
                <div className="bg-surface-light pt-20 md:pb-20 pb-10 mx-auto px-4 md:px-8">
                  <div className="max-w-screen-xl md:px-8 px-4 mx-auto flex flex-col sm:flex-row gap-14 sm:gap-8 lg:gap-16">
                    <div className="flex-1 flex flex-col gap-16 sm:gap-8 lg:gap-14">
                      <div className="h-full flex flex-col gap-2 text-lg items-start">
                        <h2 className="text-5xl lg:text-6xl relative">
                          Add-Ons
                        </h2>
                        <div className="text-left">
                          Get more out of your purchases with our valuable
                          add-ons. Our selection includes a variety of features
                          and services designed to provide additional benefits
                          and convenience. Discover how you can unlock extra
                          value and optimize your products with our add-ons.
                        </div>
                      </div>
                      <PricingCardV3
                        title={`HIPAA`}
                        description={`Add security to your medical pratice by purchasing HIPAA bussiness associate agreement.`}
                        featuresIcon={<GradientCheckIcon />}
                        features={[
                          {
                            name: "HIPAA BAA is Available on each plan as an Add-On",
                          },
                        ]}
                        price={49}
                        pricingType={"mo"}
                        cardBorder={true}
                        bgColor={"bg-pink-100"}
                        buttonText={"Subscribe"}
                        buttonUrl={`https://buy.stripe.com/dR6aI1doC7892Pe7t4`}
                        transparent={false}
                        isAnnualBilling={false}
                      />
                    </div>
                    <div className="flex-1 flex flex-col gap-16 sm:gap-8 lg:gap-16">
                      <PricingCardV3
                        title={`SMS`}
                        description={`Send documents for signing via SMS for quick and easy e-signatures.`}
                        featuresIcon={<GradientCheckIcon />}
                        features={[
                          { name: "500 SMS Credits" },
                          { name: "1 SMS Credit = 1 Send" },
                          {
                            name: "SMS is Available on each plan as an Add-On",
                          },
                        ]}
                        price={12}
                        packagesCount={"/500 SMS Credits"}
                        pricingType={"One-time"}
                        cardBorder={true}
                        bgColor={"bg-lime-200"}
                        buttonText={"Buy Now"}
                        buttonUrl={`https://buy.stripe.com/28o2bvesG2RT2Pe3d8`}
                        transparent={false}
                        isAnnualBilling={false}
                      />
                    </div>
                  </div>
                </div>

                {/* slider  */}
                <div className="w-full py-32 bg-dark">
                  <div className="max-w-screen-xl mx-auto">
                    <h1 className="text-3xl md:text-4xl leading-snug text-center mb-3 text-white font-semibold">
                      5,000+ Companies <br /> Use BoloForms Around the World
                    </h1>
                    <AnimatedLogos />
                  </div>
                </div>
              </>
            )}

            {activeTab === "API" && (
              <>
                <div className="w-full max-w-screen-xl mx-auto pt-8 sm:pt-12 md:px-8 px-4">
                  <ApiAddonPricingCard2 currentPage="api" />
                </div>

                {/* slider  */}
                <div className="w-full py-32 bg-dark">
                  <div className="max-w-screen-xl mx-auto">
                    <h1 className="text-3xl md:text-4xl leading-snug text-center mb-3 text-white font-semibold">
                      5,000+ Companies <br /> Use BoloForms Around the World
                    </h1>
                    <AnimatedLogos />
                  </div>
                </div>
              </>
            )}

            {activeTab === "CLM" && (
              <div className="w-full pt-8 sm:pt-12 text-left ">
                <RequestDemo />
              </div>
            )}
          </div>
        </div>

        <section className="bg-[#f4f2f0] text-black py-16 md:px-10 px-4 xl:px-20 text-center md:pt-24 pt-12 ">
          <FAQ />
        </section>
      </div>
      {imagePopup && (
        <FeatureInfoPopup
          image={imagePopup}
          close={() => setImagePopup(null)}
        />
      )}
    </div>
  );
};

export default Pricing;

const FreePlanAccordion = ({ setImagePopup }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="border-2 border-slate-200 rounded-3xl lg:p-6 p-4 sm:px-8 sm:py-6 w-full bg-white">
      <div className="w-full flex flex-wrap gap-4 justify-between items-center">
        <div>
          <h2 className="text-4xl font-bold text-left">Free Plan</h2>
          <p className="text-base text-left text-gray-600 mt-4 min-h-[60px] ">
            For individuals seeking the quickest way to sign or send a contract
            for signature.
          </p>
        </div>
        <div className="flex gap-4 text-xl">
          <CLMButtonPrimary
            buttonUrl={`https://signature.boloforms.com/register?from=PRICING_PAGE${createUTMQueryParams(
              {
                from: "PRICING_PAGE",
              }
            )}`}
            buttonText={"Try Now For Free"}
          />
        </div>
      </div>
      {/* {isOpen && ( */}
      <div
        className={`border-t-2 border-slate-200 mt-8 pt-6 pb-4 ${
          isOpen ? "block" : "block md:hidden"
        }`}
      >
        <div className="grid sm:grid-cols-2 gap-4">
          {freeTrialData?.features.map((feature, index) => (
            <div key={index} className="flex items-start justify-start gap-2">
              <div className=" w-6 h-6  flex items-center justify-center shrink-0">
                <GradientCheckIcon />
              </div>
              <p
                className={`text-base leading-[24px] font-medium hover:bg-gradient-to-r text-left   ${
                  feature?.image
                    ? " underline underline-offset-[5px] decoration-dotted cursor-pointer decoration-gray-400 hover:decoration-primary hover:text-primary hover:from-purple-500  hover:via-indigo-500  hover:to-blue-500  hover:bg-clip-text  hover:text-transparent "
                    : ""
                }`}
                onClick={() => feature?.image && setImagePopup(feature.image)}
              >
                {feature?.name}
              </p>
            </div>
          ))}
        </div>
      </div>
      {/* )} */}
    </div>
  );
};
